import Vue from 'vue';
import VueRouter from 'vue-router';

const configurator = () => import(/* webpackChunkName: "configurator" */ '@/views/configurator/index.vue');
const configuratorForm = () => import(/* webpackChunkName: "configurator" */ '@/views/configurator/configurator.vue');
const thankYou = () => import(/* webpackChunkName: "configurator" */ '@/views/configurator/thankYou.vue');

Vue.use(VueRouter);

const routes = [
	{
		path: '/:configuratorUID',
		props: true,
		component: configurator,
		meta: {
			layout: 'page',
		},
		children: [
			{
				path: '',
				component: configuratorForm,
				meta: {
					layout: 'page',
				},
			},
			{
				path: 'thank-you',
				name: 'thank-you',
				component: thankYou,
				meta: {
					layout: 'page',
				},
			},
		],
	},
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.VUE_APP_BASE_URL,
	routes,
});

export default router;
